import request from '@/utils/request'


// 棋牌空间服务接口：
// 房间/房间标签/时段列表/服务项目

// 新增房间：post space/createRoom，参数：
// title // 标题
// avatar // 封面
// imageList // 轮播图列表[]
// tagIdList // 标签id列表,[]
// sectionList // 时段列表,[{sectionId// 时段ID,price//价格}]
// descList // 描述文字列表,[]
// text // 备注
// order// 排序
export function createRoom(data) {
    return request({
        url: '/space/createRoom',
        method: 'post',
        data,
    })
  }
// 修改房间：post space/updateRoom，参数：
// roomId // 房间ID
// title // 标题
// avatar // 封面
// imageList // 轮播图列表[]
// tagIdList // 标签id列表,[]
// sectionList // 时段列表,[{sectionId// 时段ID,price//价格}]
// descList // 描述文字列表,[]
// text // 备注
// order// 排序
export function updateRoom(data) {
    return request({
        url: '/space/updateRoom',
        method: 'post',
        data,
    })
  }
// 删除房间：post space/removeRoom，参数：
// roomId // 房间ID
export function removeRoom(data) {
    return request({
        url: '/space/removeRoom',
        method: 'post',
        data,
    })
  }
// 获取单个房间：get space/findRoom，参数：
// roomId // 房间ID
export function findRoom(params) {
    return request({
        url: '/space/findRoom',
        method: 'get',
        params,
    })
  }
// 获取房间列表：get space/findRoomList，参数：
// tagId // 标签id，多个用,隔开
// keyword // 关键词，搜索标题
// page
// size
export function findRoomList(params) {
    return request({
        url: '/space/findRoomList',
        method: 'get',
        params,
    })
  }
// 获取所有房间：get space/findRoomAll，参数：
// tagId // 标签id，多个用,隔开
// keyword // 关键词，搜索标题
export function findRoomAll(params) {
    return request({
        url: '/space/findRoomAll',
        method: 'get',
        params,
    })
  }
// 新增房间标签：post space/createTag，参数：
// title // 标题
// text // 备注
// order// 排序
export function createTag(data) {
    return request({
        url: '/space/createTag',
        method: 'post',
        data,
    })
  }
// 修改房间标签：post space/updateTag，参数：
// tagId // 标签ID
// title // 标题
// text // 备注
// order// 排序
export function updateTag(data) {
    return request({
        url: '/space/updateTag',
        method: 'post',
        data,
    })
  }
// 删除房间标签：post space/removeTag, 参数：
// tagId // 标签ID
export function removeTag(data) {
    return request({
        url: '/space/removeTag',
        method: 'post',
        data,
    })
  }
// 获取单个房间标签：get space/findTag，参数：
// tagId // 标签ID
export function findTag(params) {
    return request({
        url: '/space/findTag',
        method: 'get',
        params,
    })
  }
// 获取房间标签列表：get space/findTagList，参数：
// keyword // 关键词，搜索标题
// page
// size
export function findTagList(params) {
    return request({
        url: '/space/findTagList',
        method: 'get',
        params,
    })
  }
// 获取所有房间标签：get space/findTagAll，参数：
// keyword // 关键词，搜索标题
export function findTagAll(params) {
    return request({
        url: '/space/findTagAll',
        method: 'get',
        params,
    })
  }
// 新增可预约时段：post space/createSection，参数：
// title // 标题
// startTime // 开始时间，HH:mm:ss
// endTime // 结束时间，HH:mm:ss
// text // 备注
// order// 排序
export function createSection(data) {
    return request({
        url: '/space/createSection',
        method: 'post',
        data,
    })
  }
// 修改可预约时段：post space/updateSection，参数：
// sectionId // 可预约时段ID
// title // 标题
// startTime // 开始时间，HH:mm:ss
// endTime // 结束时间，HH:mm:ss
// text // 备注
// order// 排序
export function updateSection(data) {
    return request({
        url: '/space/updateSection',
        method: 'post',
        data,
    })
  }
// 删除可预约时段：post space/removeSection, 参数：
// sectionId // 标签ID
export function removeSection(data) {
    return request({
        url: '/space/removeSection',
        method: 'post',
        data,
    })
  }
// 获取单个可预约时段：get space/findSection，参数：
// sectionId // 标签ID
export function findSection(params) {
    return request({
        url: '/space/findSection',
        method: 'get',
        params,
    })
  }
// 获取可预约时段列表：get space/findSectionList，参数：
// keyword // 关键词，搜索标题
// page
// size
export function findSectionList(params) {
    return request({
        url: '/space/findSectionList',
        method: 'get',
        params,
    })
  }
// 获取所有可预约时段：get space/findSectionAll，参数：
// keyword // 关键词，搜索标题
export function findSectionAll(params) {
    return request({
        url: '/space/findSectionAll',
        method: 'get',
        params,
    })
  }
// 新增服务项目：post space/createService，参数：
// title // 标题
// price // 价格
// text // 备注
// order// 排序
export function createService(data) {
    return request({
        url: '/space/createService',
        method: 'post',
        data,
    })
  }
// 修改服务项目：post space/updateService，参数：
// serviceId // 服务项目ID
// title // 标题
// price // 价格
// text // 备注
// order// 排序
export function updateService(data) {
    return request({
        url: '/space/updateService',
        method: 'post',
        data,
    })
  }
// 删除服务项目：post space/removeService, 参数：
// serviceId // 服务项目ID
export function removeService(data) {
    return request({
        url: '/space/removeService',
        method: 'post',
        data,
    })
  }
// 获取单个服务项目：get space/findService，参数：
// serviceId // 服务项目ID
export function findService(params) {
    return request({
        url: '/space/findService',
        method: 'get',
        params,
    })
  }
// 获取服务项目列表：get space/findServiceList，参数：
// keyword // 关键词，搜索标题
// page
// size
export function findServiceList(params) {
    return request({
        url: '/space/findServiceList',
        method: 'get',
        params,
    })
  }
// 获取所有服务项目：get space/findServiceAll，参数：
// keyword // 关键词，搜索标题
export function findServiceAll(params) {
    return request({
        url: '/space/findServiceAll',
        method: 'get',
        params,
    })
  }

// 预订单退款：post space/refundOrder, 参数：
// orderId // 订单Id
// refundAmount // 退款金额
// refundReason // 退款原因
export function refundOrder(data) {
    return request({
        url: '/space/refundOrder',
        method: 'post',
        data,
    })
  }
// 获取单个预订单：get space/findOrder, 参数：
// orderId // 订单ID
export function findOrder(params) {
    return request({
        url: '/space/findOrder',
        method: 'get',
        params,
    })
  }

// 后台获取预订单列表：get space/findOrderList, 参数：
// orderNo // 订单号
// keyword // 关键词，搜索订单标题
// page
// size
export function findOrderList(params) {
    return request({
        url: '/space/findOrderList',
        method: 'get',
        params,
    })
  }
// 后台导出预订单：get space/exportOrder, 参数：
// orderNo // 订单号
// keyword // 关键词，搜索订单标题
export function exportOrder(params) {
    return request({
        url: '/space/exportOrder',
        method: 'get',
        params,
    })
  }